module.exports = __webpack_public_path__ + "img/vertical_6_4_8019.2fff4f1a.png";